import { useDatasets } from './useDatasets';
import { useWildfireMode } from './useWildfireMode';

/**
 * Whether to display wildfire priority (WPL) for the selected release.
 *
 * - `none`: never.
 * - `all`: always. WPL is computed from burnability.
 * - `legacy` and `fuels-only`: only if the release has legacy WPL data.
 */
export const useHasWildfirePriority = (): boolean => {
  const mode = useWildfireMode();
  const { datasets, isSuccess } = useDatasets();

  if (mode === 'none') return false;
  if (mode === 'all') return true;
  return (
    isSuccess && datasets.some((d) => d.layerType === 'wildfire_priority_level')
  );
};
